import BOT_USER_AGENTS from '~/const/botUserAgent';

var isSearchEngine = agent => !!BOT_USER_AGENTS.find(bot => agent && agent.toLowerCase().indexOf(bot.toLowerCase()) !== -1);

export default isSearchEngine;